import {routing} from "@/i18n/routing";

// Longest-first so "es-mx" is matched before "es".
const LOCALE_PREFIX = new RegExp(
    `^/(?:${[...routing.locales].sort((a, b) => b.length - a.length).join('|')})(?=/|$)`,
);

/**
 * Strip the leading locale segment off a pathname so it can be re-prefixed with
 * a new locale on language switch.
 *
 * Pass `window.location.pathname` (the real, current URL) rather than next-intl's
 * `usePathname()`: after a client-side locale switch the next-intl locale context
 * (its provider lives in the persistent root layout and doesn't re-render) goes
 * stale, so `usePathname()` returns a still locale-prefixed path. Re-prefixing
 * that produced double-locale URLs like "/es-pe/es-cl/..." → 404.
 */
export function localelessPath(pathname: string): string {
    return pathname.replace(LOCALE_PREFIX, '') || '/';
}
